import {yoguHardware} from '../../../shared/yogu-hardware.js';
import React from 'react';
import {Text} from '../copy';
import {useLive} from '../live';
import {Screen,Title,Card,Row} from '../components/primitives';
import {BatteryAlertsPanel} from '../../BatteryAlertsPanel';
import {GpsFeatureMenu} from './GpsFeaturesScreen';
import {FeatureList} from '../components/FeatureList';
import {features} from '../domain/featureCatalog';
import {alarmFeatureIds,hasAlarmTab} from '../../../shared/device-profile.js';

/** Alarm settings are separate from the received event history. */
export function AlarmsScreen(){
  const {state,locale,actions}=useLive(),device=state.snapshot?.device,da=locale==='da-DK';
  if(!hasAlarmTab(device))return null;
  return <Screen testID="alarms-screen">
    <Title subtitle={da?'Tilpas alarmer og vælg, hvordan du får besked.':'Configure alerts and choose how you receive notifications.'}>{da?'Alarmer':'Alarms'}</Title>
    {device?.profile?.protocol==='gt06'?<GpsFeatureMenu section="alarms"/>:<FeatureList features={features.filter(f=>alarmFeatureIds.includes(f.id))} onOpen={actions.openScreen}/>}
    {device?.profile?.protocol==='gt06'&&device.profile.timeZoneConfirmed===false&&<Card tone="attention"><Text>{da?'Sikkerhedszoner og hastighedsalarmer er ikke klar endnu. Kontakt Qtracker for at færdiggøre opsætningen.':'Safe zones and speed alerts are not ready yet. Contact Qtracker to complete setup.'}</Text></Card>}
    {yoguHardware(device?.profile)?.lightSensor==='observed'&&<Card><Row title={da?'Lyssensor og afmontering':'Light sensor and removal'} icon="warning" subtitle={da?'En lyssensor er registreret på modellen. Afmonteringsalarmen kan endnu ikke indstilles eller bekræftes aktiv i appen.':'A light sensor is recorded for this model. The app cannot yet configure or confirm an active removal alarm.'}/></Card>}
    <BatteryAlertsPanel/>
  </Screen>;
}
